export { AccountIdentityCard, ACCOUNT_AVATAR_SIZE } from "./AccountIdentityCard"
export type { AccountIdentityCardProps, UIStudentAccountIdentity } from "./AccountIdentityCard"
